/* eslint-disable */
const Fetch_CASH_BACK = "Fetch_CASH_BACK";

const initialState = [];

export const fetchCashBack = (payload) => ({
  type: Fetch_CASH_BACK,
  payload,
});

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case Fetch_CASH_BACK:
      return action.payload;
    default:
      return state;
  }
};

export default reducer;
